/**
 * @generated SignedSource<<3d751d8663e9b01c83baf8ee36ee3ff8>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endTimeOfDay",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startTimeOfDay",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            (v6 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    }, v8 = [
        {
            "kind": "Literal",
            "name": "unit",
            "value": "MINUTE"
        }
    ], v9 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        }
    ], v10 = {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleTemplateShiftBreak",
        "kind": "LinkedField",
        "name": "breaks",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": (v8 /*: any*/),
                "concreteType": "TimeSpanUnitValue",
                "kind": "LinkedField",
                "name": "offsetEnd",
                "plural": false,
                "selections": (v9 /*: any*/),
                "storageKey": "offsetEnd(unit:\"MINUTE\")"
            },
            {
                "alias": null,
                "args": (v8 /*: any*/),
                "concreteType": "TimeSpanUnitValue",
                "kind": "LinkedField",
                "name": "offsetStart",
                "plural": false,
                "selections": (v9 /*: any*/),
                "storageKey": "offsetStart(unit:\"MINUTE\")"
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entityDisabled",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schedulable",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
    }, v15 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "assignedEntity",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    (v2 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            (v11 /*: any*/),
                            (v6 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v12 /*: any*/),
                    (v13 /*: any*/)
                ],
                "type": "SchedulableAsset",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    (v2 /*: any*/),
                    (v12 /*: any*/),
                    (v13 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            (v11 /*: any*/),
                            (v14 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "type": "SchedulableUser",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    (v2 /*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
            }
        ],
        "storageKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "concreteType": "AssignmentType",
        "kind": "LinkedField",
        "name": "assignmentType",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            (v16 /*: any*/)
        ],
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleTemplateId",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditScheduleTemplateShiftModalUpdateMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateScheduleTemplateShiftPayload",
                    "kind": "LinkedField",
                    "name": "updateScheduleTemplateShift",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleTemplateShift",
                            "kind": "LinkedField",
                            "name": "shiftEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleTemplateShift",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleTemplateShift_shift"
                                        },
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        (v7 /*: any*/),
                                        (v10 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplatePeriod",
                                            "kind": "LinkedField",
                                            "name": "period",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "ScheduleTemplatePeriod_period"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditScheduleTemplateShiftModalUpdateMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateScheduleTemplateShiftPayload",
                    "kind": "LinkedField",
                    "name": "updateScheduleTemplateShift",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleTemplateShift",
                            "kind": "LinkedField",
                            "name": "shiftEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleTemplateShift",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v15 /*: any*/),
                                        (v17 /*: any*/),
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        (v7 /*: any*/),
                                        (v10 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleTemplatePeriod",
                                            "kind": "LinkedField",
                                            "name": "period",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleTemplatePeriodDayConnection",
                                                    "kind": "LinkedField",
                                                    "name": "days",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleTemplatePeriodDayEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleTemplatePeriodDay",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "weekday",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "dayInPeriod",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleTemplatePeriod",
                                                                            "kind": "LinkedField",
                                                                            "name": "period",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v18 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleTemplatePeriodDayShiftGroupByAssignmentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupedShifts",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ScheduleTemplatePeriodDayShiftGroupByAssignmentTypeGroupingKey",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "group",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v17 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ScheduleTemplateShiftGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "shiftsGroups",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "ScheduleTemplateShiftGroupGroupingKey",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v5 /*: any*/),
                                                                                                (v4 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": (v8 /*: any*/),
                                                                                                    "concreteType": "TimeSpanUnitValue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "duration",
                                                                                                    "plural": false,
                                                                                                    "selections": (v9 /*: any*/),
                                                                                                    "storageKey": "duration(unit:\"MINUTE\")"
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Event",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "event",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v2 /*: any*/),
                                                                                                        (v6 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "ScheduleTemplateShift",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "shifts",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                (v2 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "unit",
                                                                                                            "value": "HOUR"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "TimeSpanUnitValue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "duration",
                                                                                                    "plural": false,
                                                                                                    "selections": (v9 /*: any*/),
                                                                                                    "storageKey": "duration(unit:\"HOUR\")"
                                                                                                },
                                                                                                (v17 /*: any*/),
                                                                                                (v10 /*: any*/),
                                                                                                (v4 /*: any*/),
                                                                                                (v5 /*: any*/),
                                                                                                (v15 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "ScheduleShiftAssetValidation",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "assetValidations",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "SchedulableAsset",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "schedulableAsset",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Asset",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "asset",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v2 /*: any*/),
                                                                                                                        (v6 /*: any*/),
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "assetNumber",
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "validateProficiency",
                                                                                                                            "storageKey": null
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v2 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "SchedulableUser",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "schedulableUser",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "User",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "user",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v14 /*: any*/),
                                                                                                                        (v2 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v2 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "AssignmentType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "userAssignmentType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v16 /*: any*/),
                                                                                                                (v2 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "AssetProficiencyValidation",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "assetProficiency",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isValid",
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v6 /*: any*/),
                                                (v18 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "73a6f751a550cef29b2bd91e0c3c49f7",
            "id": null,
            "metadata": {},
            "name": "EditScheduleTemplateShiftModalUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation EditScheduleTemplateShiftModalUpdateMutation(\n  $model: UpdateScheduleTemplateShiftRequestInput!\n) {\n  updateScheduleTemplateShift(model: $model) {\n    shiftEdge {\n      node {\n        id\n        ...ScheduleTemplateShift_shift\n        description\n        endTimeOfDay\n        startTimeOfDay\n        event {\n          name\n          id\n        }\n        breaks {\n          offsetEnd(unit: MINUTE) {\n            value\n          }\n          offsetStart(unit: MINUTE) {\n            value\n          }\n          type\n        }\n        period {\n          ...ScheduleTemplatePeriod_period\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SchedulableAsset_entity on SchedulableAsset {\n  id\n  asset {\n    id\n    color\n    name\n  }\n  entityDisabled\n  schedulable\n}\n\nfragment SchedulableUser_entity on SchedulableUser {\n  id\n  entityDisabled\n  schedulable\n  user {\n    id\n    color\n    fullName\n  }\n}\n\nfragment ScheduleTemplatePeriodDay_day on ScheduleTemplatePeriodDay {\n  id\n  dayInPeriod\n  weekday\n  period {\n    id\n    scheduleTemplateId\n  }\n  groupedShifts {\n    group {\n      assignmentType {\n        id\n        title\n      }\n    }\n    shiftsGroups {\n      group {\n        startTimeOfDay\n        endTimeOfDay\n        duration(unit: MINUTE) {\n          value\n        }\n        event {\n          id\n          name\n        }\n      }\n      shifts {\n        id\n        duration(unit: HOUR) {\n          value\n        }\n        assignmentType {\n          id\n          title\n        }\n        breaks {\n          offsetEnd(unit: MINUTE) {\n            value\n          }\n          offsetStart(unit: MINUTE) {\n            value\n          }\n          type\n        }\n        endTimeOfDay\n        startTimeOfDay\n        ...ScheduleTemplateShift_shift\n      }\n      ...ScheduleTemplateShiftAssetValidationGroup_scheduleTemplateShift\n    }\n  }\n}\n\nfragment ScheduleTemplatePeriod_period on ScheduleTemplatePeriod {\n  id\n  days {\n    edges {\n      node {\n        id\n        weekday\n        ...ScheduleTemplatePeriodDay_day\n      }\n    }\n  }\n  name\n  scheduleTemplateId\n}\n\nfragment ScheduleTemplateShiftAssetValidationGroup_scheduleTemplateShift on ScheduleTemplateShiftGroup {\n  shifts {\n    assetValidations {\n      schedulableAsset {\n        asset {\n          id\n          name\n          assetNumber\n          validateProficiency\n        }\n        id\n      }\n      schedulableUser {\n        user {\n          fullName\n          id\n        }\n        id\n      }\n      userAssignmentType {\n        title\n        id\n      }\n      assetProficiency {\n        isValid\n      }\n    }\n    id\n  }\n}\n\nfragment ScheduleTemplateShift_shift on ScheduleTemplateShift {\n  id\n  assignedEntity {\n    __typename\n    ...SchedulableAsset_entity\n    ...SchedulableUser_entity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  assignmentType {\n    id\n    title\n  }\n}\n"
        }
    };
})();
node.hash = "36f75888d00b24a9d5f229b7b5cc2058";
export default node;
